document.addEventListener("DOMContentLoaded", () => {
  const marqueeWrappers = document.querySelectorAll(".infinite-scroller-marquee-wrapper");

  marqueeWrappers.forEach((wrapper) => {
    const isScrollingDisabled = wrapper.getAttribute("data-disable-scrolling") === "true";
    const marquee = wrapper.querySelector(".infinite-scroller-marquee-content");

    if (!marquee) return;

    const reviewSegments = marquee.querySelectorAll(".marquee-segment--review");

    if (reviewSegments.length > 0) {
      // Fisher-Yates shuffle — proper uniform randomness, no adjacent duplicates possible
      const reviews = Array.from(reviewSegments);
      for (let i = reviews.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [reviews[i], reviews[j]] = [reviews[j], reviews[i]];
      }

      const html = reviews.map((el) => el.outerHTML).join("");

      // Single duplication is sufficient for seamless CSS looping.
      // The seam between the two copies is always different reviews
      // since first and last of the shuffled set are distinct.
      marquee.innerHTML = isScrollingDisabled ? html : html + html;
    } else {
      // Text mode: duplicate once for seamless looping
      if (!isScrollingDisabled) {
        marquee.innerHTML += marquee.innerHTML;
      }
    }
  });
});
